// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__t8tCg","colCheckbox":"styles_colCheckbox__3MVZj"};